"use client";

import { styled } from "styled-components";

import {
  poppins_body_sm_medium,
  poppins_body_sm_semibold,
} from "../../../../shared/font/poppins/body";

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0.8rem;
  flex-wrap: nowrap;
  width: max-content;
  min-height: 2.4rem;
`;

export const CountBadge = styled.span`
  display: inline-flex;
  box-sizing: border-box;
  width: 3.7rem;
  flex-shrink: 0;
  height: 2rem;
  padding: 0.2rem 0.7rem;
  ${poppins_body_sm_semibold}
  color: #0198e9;
  background: #f0f9ff;
  border-radius: 0.4rem;
  align-items: center;
  justify-content: center;
  font-variant-numeric: tabular-nums;
`;

export const SliderScale = styled.div`
  display: flex;
  align-items: center;
  gap: 0.8rem;
  width: 24rem;
  max-width: 24rem;
  flex-shrink: 0;
`;

export const SliderMinLabel = styled.span`
  ${poppins_body_sm_medium}
  color: #515c6c;
  width: 0.7rem;
  flex-shrink: 0;
  font-variant-numeric: tabular-nums;
`;

export const SliderTrackWrapper = styled.div`
  position: relative;
  flex: 1;
  min-width: 0;
  height: 2rem;
  display: flex;
  align-items: center;
  cursor: pointer;
`;

export const SliderTrack = styled.div`
  position: relative;
  width: 100%;
  height: 0.6rem;
  background: #cbd0d8;
  border-radius: 0.4rem;
`;

export const SliderFill = styled.div<{ $pct: number }>`
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: ${({ $pct }) => $pct}%;
  background: #1baefe;
  border-radius: 0.4rem;
`;

export const SliderTick = styled.div<{ $pct: number }>`
  position: absolute;
  left: ${({ $pct }) => $pct}%;
  top: 50%;
  width: 0.2rem;
  height: 0.6rem;
  border-radius: 10rem;
  background: #ffffff;
  transform: translate(-50%, -50%);
  pointer-events: none;
  z-index: 1;
`;

export const SliderThumb = styled.div<{ $pct: number }>`
  position: absolute;
  width: 1.6rem;
  height: 1.6rem;
  border-radius: 50%;
  background: #fff;
  border: 4px solid #1baefe;
  left: calc(${({ $pct }) => $pct}% - 0.8rem);
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
  z-index: 2;
`;

export const SliderInput = styled.input`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  opacity: 0;
  cursor: grab;
  margin: 0;
  z-index: 3;
  -webkit-appearance: none;
  appearance: none;

  &:active {
    cursor: grabbing;
  }

  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    width: 1.6rem;
    height: 1.6rem;
    border-radius: 50%;
    cursor: grab;
  }

  &::-moz-range-thumb {
    width: 1.6rem;
    height: 1.6rem;
    border-radius: 50%;
    cursor: grab;
    border: none;
  }
`;

export const SliderMaxLabel = styled.span`
  ${poppins_body_sm_medium}
  color: #515c6c;
  width: 2.5rem;
  flex-shrink: 0;
  font-variant-numeric: tabular-nums;
`;
